<template>
  <div class="menu-helper">
    <SiteSelect />
    <div class="ui-helper">
      <a v-if="isDesktop" class="nav-cta map-cta" :class="{ active: $route.name === 'result' }" @click="openMenu()">{{ $t('sections.mapView') }}</a>
      <div class="casual-nav">
        <a class="nav-cta" :class="{ active: $route.hash === '#synthesis' || $route.name === 'synthesis' }" @click="openMenu('SYNTHESIS', 'synthesis')">{{
          $t('sections.synthesis')
        }}</a>
        <a class="nav-cta" :class="{ active: $route.hash === '#transit' || $route.name === 'transit' }" @click="openMenu('TRANSIT', 'transit')">{{
          $t('sections.transit')
        }}</a>
        <a
          v-if="!currentSiteOnly"
          class="nav-cta"
          :class="{ active: $route.hash === '#impact' || $route.name === 'impact' }"
          @click="openMenu('IMPACT', 'impact')"
          >{{ $t('sections.impact') }}</a
        >
        <a
          v-if="!currentSiteOnly"
          class="nav-cta"
          :class="{ active: $route.hash === '#outlier' || $route.name === 'outlier' }"
          @click="openMenu('OUTLIER', 'outlier')"
          >{{ $t('sections.outlier') }}</a
        >
        <a
          class="nav-cta"
          :class="{ active: $route.hash === '#environmental' || $route.name === 'environmental' }"
          @click="openMenu('ENVIRONMENTAL', 'environmental')"
          >{{ $t('sections.environmental') }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SiteSelect from '@/components/Map/SiteSelect';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  name: 'MenuHelper',

  components: {
    SiteSelect,
  },

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      study: 'study',
    }),

    currentSiteOnly() {
      if (this.study) {
        return !(this.study.sites.filter(site => site.type_id === 2).length > 0);
      }
      return false;
    },
  },

  created() {
    this.$socket = useSignalR();
  },

  methods: {
    openMenu(menu, hash) {
      if (!this.isDesktop || this.$route.name === 'Controller') {
        if (hash) {
          this.$router.push({ hash });
        }
        this.$store.dispatch('selectMenu', menu);
        this.$socket.invoke('action', { action: 'selectMenu', parameters: menu });

        if (this.study && this.study.collaborators_total > 2000) {
          const id = this.study.id || this.$route.params.studyId;
          this.$store.dispatch('uploadRawData', { id: id, content: this.$store.getters.screen() }).then(result => {
            this.$socket.invoke('action', { action: 'tvBlob', parameters: result });
          });
        } else {
          this.$socket.invoke('action', { action: 'tvData', parameters: this.$store.getters.screen() });
        }
      } else {
        if (this.$route.name !== hash && hash) {
          this.$router.push({ name: hash, params: this.$route.params });
        } else {
          this.$router.push({ name: 'result', params: this.$route.params });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.menu-helper {
  height: 54px;
  background-color: colors.$beige-color;
  display: flex;
  flex: 1;
  align-items: center;
  .ui-helper {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 20px;
    .casual-nav {
      display: flex;
      height: 100%;
      padding-left: 20px;
    }
    .nav-cta {
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 100%;
      font-size: 14px;
      font-weight: 700;
      padding-left: 12px;
      padding-right: 12px;
      text-decoration: none;
      color: colors.$concrete-color;
      box-sizing: border-box;
      border-top: 3px solid transparent;
      border-bottom: 3px solid transparent;
      transition:
        border-bottom-color 0.3s ease,
        color 0.3s ease;
      text-transform: uppercase;
      & + .nav-cta {
        margin-left: 20px;
      }
      &:hover {
        color: colors.$stone-color;
        border-bottom-color: #318eaf;
      }
      &.active {
        color: colors.$stone-color;
        border-bottom-color: colors.$red-active-color;
      }
    }
  }
}
</style>
